module.exports = __webpack_public_path__ + "img/romaebus_hero_bg.0efe12fd.png";